import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {ModalComponent} from '../../../../../../components/Layout/Modal'
import {InputNumberDecimal, InputText, InputTextArea} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {useCentral} from '../../../../../../hooks/useCentral'
import {SelectOption} from '../../../../../../models/utility.model'
import {SUCCESS_MESSAGE_CREATE, SUCCESS_MESSAGE_UPDATE} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ClotheModel, UpdateClotheForm} from '../../../../model'
import {personClothing} from '../../../../schema/person'
import {createClotheByPerson, getMasterService, updateClotheByPerson} from '../../../../services'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getClothesByPersonId: () => void
  setIdClotheList: () => void
  idClothe?: ''
  detailClothe?: ClotheModel
}

const AddClothes: FC<Props> = ({
  show,
  setShow,
  setIdClotheList,
  getClothesByPersonId,
  idClothe,
  detailClothe,
}) => {
  const {currentTabItem} = useCentral()
  const [clothingType, setClothingType] = useState<SelectOption[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const methods = useForm<UpdateClotheForm>({
    resolver: yupResolver(personClothing),
    criteriaMode: 'all',
    reValidateMode: 'onChange',
    mode: 'all',
  })
  const {
    setValue,
    setError,
    reset,
    clearErrors,
    watch,
    control,
    register,
    formState: {errors},
  } = methods
  useEffect(() => {
    return () => {
      clearErrors()
    }
  }, [])
  useEffect(() => {
    if (idClothe) {
      setValue('TipoPrendaId', detailClothe?.TipoPrendaId || '')
      setValue('Cantidad', detailClothe?.Cantidad)
      setValue('CodigoPrenda', detailClothe?.CodigoPrenda || '')
      setValue('Observacion', detailClothe?.Observacion || '')
    }
  }, [idClothe])

  const getClothingTypeList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRopa',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setClothingType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getClothingTypeList()
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdClotheList()
    clearErrors()
  }

  const onSubmit = async (data: UpdateClotheForm) => {
    try {
      setLoading(true)
      const isCreating = !idClothe
      const response = isCreating
        ? await createClotheByPerson({personaId: currentTabItem.idToEdit, ...data})
        : await updateClotheByPerson({
            ...data,
            personaId: currentTabItem.idToEdit,
            Id: idClothe,
          })
      if (!response.data.error) {
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        ShowSnackBar(messageResponse)
        handleClose()
        getClothesByPersonId()
      } else {
        ShowSnackBar(response.data.message, 'error')
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  let text = idClothe ? 'Editar Prenda' : 'Agregar Prenda'

  const handleSave = methods.handleSubmit(onSubmit)

  return (
    <ModalComponent
      show={show}
      title={text}
      handleSubmit={handleSave}
      handleClose={handleClose}
      disabledSubmit={loading}
      size='lg'
    >
      <FormProvider {...methods}>
        <form>
          <div className='row'>
            <div className='mb-2 col-6'>
              <label className='required'>Tipo de ropa</label>
              <Select
                control={control as any}
                name='TipoPrendaId'
                data={clothingType}
                errors={errors}
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label className='required'>Cantidad:</label>
              <InputNumberDecimal
                name='Cantidad'
                textPlaceholder='Escribe la cantidad'
                register={register}
                errors={errors}
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <div className='d-flex justify-content-between align-items-center pe-6'>
                <label className='required'>Codigo de prenda</label>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <label className='form-check-label me-2' htmlFor='switchPeso'>
                    Automático
                  </label>
                  <input
                    className='form-check-input h-20px w-30px'
                    type='checkbox'
                    // checked={isAutomaticWeight}
                    // defaultChecked={isAutomaticWeight}
                    // onChange={() => setIsAutomaticWeight(!isAutomaticWeight)}
                    // id='switchPeso'
                  />
                </div>
              </div>
              <InputText
                name='CodigoPrenda'
                textPlaceholder='Correlativo autogenerado de 8 digitos'
                register={register}
                errors={errors}
              />
            </div>

            <div className='col-sm-12 col-lg-12'>
              <label>Detalle de Observación:</label>
              <InputTextArea
                name='Observacion'
                textPlaceholder='Escribe la observación'
                register={register}
                errors={errors}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {AddClothes}
